// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false, 
  homePath: '/text-entry',
  configPath: 'assets/config.json',
  server: 'http://numinus:2265',
  emtelliproServer: 'http://numinus:2265',
  iamServer: 'http://numinus:12265',
  commitId: '99fb93bb',
  timeStamp: '2024.12.11'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
